import { createSlice } from "@reduxjs/toolkit";
import Api from "../../api/Api";
import {IObjectKeys} from "../../constants/interfaces";

type State = {
	data: IObjectKeys,
	isLoading: boolean,
	isUpdating: number,
	error: Object | null
}

// Slice
const slice = createSlice({
	name: "videolist",
	initialState: {
		data: {},
		isLoading: false,
		isUpdating: -1,
		error: null
	},
	reducers: {
		fetchVideoListStart: (state: State) => {
			state.isLoading = true;
		},
		updateVideoListBySortStart: (state : State, action) => {
			state.isUpdating = action.payload;
		},
		fetchVideoListSuccess: (state: State, action) => {
			if (action.payload && action.payload.data) {
				state.data[action.payload.cellId] = action.payload.data.map((item: any) => {
					return {
						brandId: item.brandId,
						brandName: item.brandName,
						relationId: item.relationId,
						total: item.total,
						totalWeb: item.totalWeb,
						totalApp: item.totalApp,
						pubdate: item.timestamp ? Date.parse(item.timestamp) : "",
						title: item.title,
						relativeChannels: item.channels,
						trend: item.trend,
						uri: item.uri
					}
				});
			}
			state.isLoading = false;
			state.isUpdating = -1;
		},
		fetchVideoListFailed: (state: State, action) => {
			state.isLoading = false;
			state.isUpdating = -1;
			state.error = action.payload;
		}
	},
});

export default slice.reducer;

// Actions
const {
	fetchVideoListStart,
	fetchVideoListSuccess,
	fetchVideoListFailed,
	updateVideoListBySortStart
} = slice.actions;

export const getVideoList = (brands: string, interval: any, sections: string, tags: string, order: string, cellId: number) => async (dispatch: Function) => {
	try {
		dispatch(fetchVideoListStart());
		const api = new Api();
		const result = await api.getVideoList(brands, interval, sections, tags, order);
		const payload = {
			data: result,
			cellId
		}
		if (result !== "No internet connection") {
			dispatch(fetchVideoListSuccess(payload));
		}
	} catch (err: any) {
		dispatch(fetchVideoListFailed(err));
	}
};


export const updateVideoListBySort = (brands: string, interval: any, sections: string, tags: string, order: string, cellId: number) => async (dispatch: Function) => {
	try {
		dispatch(updateVideoListBySortStart(cellId));
		const api = new Api();
		const result = await api.getVideoList(brands, interval, sections, tags, order);
		const payload = {
			data: result,
			cellId
		}
		dispatch(fetchVideoListSuccess(payload));
	} catch (err: any) {
		dispatch(fetchVideoListFailed(err));
	}
};